<template>
  <div id="app">
    <el-row :gutter="20">
      <!-- gutter 栅格间距 -->
      <el-col :span="6" :offset="9">
        <!-- span 栅格占的列数，offset是偏移列数 -->
        <div class="grid-content"></div>
      </el-col>
    </el-row>

    <el-row :gutter="20" >
      <!-- gutter 栅格间距 -->
          <el-col :span="6" :offset="9"> 
            <!-- span 栅格占的列数，offset是偏移列数 -->
              <el-card shadow="always">
                <div class="content"><h1>欢迎注册(杜老师)</h1></div>
                <el-divider></el-divider>
                <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                  <el-form-item label="用户名" prop="姓名">
                    <el-input type="text" v-model="ruleForm.姓名" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="生日" prop="生日">
                    <el-date-picker
                      v-model="ruleForm.生日"
                      type="date"
                      placeholder="选择日期"
                      value-format="yyyy-MM-dd"
                      >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="密码" prop="口令">
                    <el-input type="password" v-model="ruleForm.口令" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="确认密码" prop="checkPass">
                    <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="年龄" prop="年龄">
                    <el-input v-model.number="ruleForm.年龄"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                    <el-button @click="resetForm('ruleForm')">重置</el-button>
                    <a href="../index_du.html"><el-button type="success" ><i class="el-icon-position"></i>返回</el-button></a>
                  </el-form-item>
                </el-form>
              </el-card>
          </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
    data() {
      var checkName = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('姓名不能为空'));
        };
      };

      var checkBirthday = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('生日不能为空'));
        }
        setTimeout(() => {
          if (!new Date(value)) {
            callback(new Error('请输入日期值'));
          } else {
            if (new Date(value) > new Date() - 365*18*24*60*60*1000) {
              callback(new Error('必须年满18岁'));
            } else {
              callback();
            }
          }
        }, 1000);
      };

      var checkAge = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('年龄不能为空'));
        }
        setTimeout(() => {
          if (!Number.isInteger(value)) {
            callback(new Error('请输入数字值'));
          } else {
            if (value < 18) {
              callback(new Error('必须年满18岁'));
            } else {
              callback();
            }
          }
        }, 1000);
      };

      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass');
          }
          callback();
        }
      };

      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm.口令) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      
      return {
        ruleForm: {
          姓名: '',
          生日: '',
          口令: '',
          checkPass: '',
          年龄: ''
        },
        rules: {
          姓名: [
            { validator: checkName, trigger: 'blur' },
            { pattern: '^[\u4e00-\u9fa5]+$/[2-9]', message: '请输入2-9个汉字' }
          ],
          生日: [
            { validator: checkBirthday, trigger: 'blur' }
          ],
          口令: [
            { validator: validatePass, trigger: 'blur' }
          ],
          checkPass: [
            { validator: validatePass2, trigger: 'blur' }
          ],
          年龄: [
            { validator: checkAge, trigger: 'blur' }
          ]
        }
      };
    },
    methods: {
      submitForm(formName) {
        alert('submit!执行');
        this.$refs[formName].validate((valid) => {
          if (valid) {
            alert('submit!');
          } else {
            alert('error submit!!');
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    }
  }
</script>

<style>
  .content{
    margin: 0 auto;
  }
  .el-card{
    border-radius:20px;
    /* background: rgb(241, 241, 241); */
  }
  .grid-content {
    /* background: rgb(14, 214, 131); */
    border-radius: 4px;
    min-height: 20px;
  }
  .el-row {
    margin-bottom: 20px;
  }
  a {
    margin-left: 20px;
  }
  .el-header {
    background-color: #B3C0D1;
    color: #333;
    line-height: 60px;
  }
  
  .el-aside {
    color: #333;
  }
</style>
